import { getUnitLabel } from './getUnitLabel'

// Pagination
export const getCurrentSectionIndex = (sections, currentId) => {
  if (!sections) return 0
  return sections.findIndex((s) => s.id === currentId)
}

export const getTypeSectionForIndex = (section) => {
  const { title, label, type } = section

  const labelSuffix = /[?!:.]$/.test(label) ? '' : '.'
  const typeSuffix = type && type !== title && /[?!:.]$/.test(type) ? '' : '.'

  if (!label && type === title) return ''

  return `
    ${label ? `${label}${labelSuffix} ` : ''}
    ${type && type !== title ? `${type}${typeSuffix}` : ''}
  `
}

export const getSectionFullTitle = (section) => {
  if (!section) return ''

  return `
    ${getTypeSectionForIndex(section)}
    ${section.title ? section.title : ''}
  `
}

export const getUnitFullTitle = (collection, publisher, unit) => {
  if (!unit) return ''
  if (unit.label)
    return `${getUnitLabel({
      collection,
      hasEndpoint: true,
      labelSuffix: unit.label,
      publisher,
    })} ${unit.title}`
  return unit.title
}

export const getPreviousSection = (sections, currentSectionId) => {
  const currentIndex = sections.findIndex((s) => s.id === currentSectionId)
  return sections[currentIndex - 1]
}

export const isFirstSection = (sections, sectionId) => {
  const currentIndex = sections.findIndex((s) => s.id === sectionId)
  return currentIndex === 0
}

export const getNextSection = (sections, currentSectionId) => {
  const currentIndex = sections.findIndex((s) => s.id === currentSectionId)
  return sections[currentIndex + 1]
}

export const isLastSection = (sections, sectionId) => {
  if (!sections) return false
  const currentIndex = sections.findIndex((s) => s.id === sectionId)
  return currentIndex === sections.length - 1
}

export const getCurrentActivity = (section, activityId) => {
  if (!section) return undefined
  return section.allActivities.find((activity) => activity.id === activityId)
}

export const isActivitySection = (section) => {
  return (
    section?.blockType === 'reto' ||
    section?.blockType === 'actividades' ||
    section?.blockType === 'lectura'
  )
}

export const getVisibleSections = (currentUnit) => {
  if (!currentUnit?.sections) return []
  return currentUnit.sections.filter((s) => s.isVisible !== false)
}

export const getHiddenSections = (currentUnit) => {
  if (!currentUnit?.sections) return []
  return currentUnit.sections.filter((s) => s.isVisible === false)
}

export const getFeedbackValue = (result) => {
  return result.liked === true ? 1 : result.liked === false ? -1 : 0
}

export const getVisibleUnits = (topic) => {
  return topic.units.filter((u) => u.isVisible !== false)
}

//Este código se usa para dos formatos igual habría que hacer un utils común para htmlBook como para paperview
export const getAllVisibleUnits = (topics) => {
  if (!topics) return []
  return topics.flatMap((topic) => getVisibleUnits(topic))
}

export const getPreviousUnit = (bookStructure, currentUnitId) => {
  if (!bookStructure?.topics) return null
  const allUnits = getAllVisibleUnits(bookStructure.topics)
  const currentIndex = allUnits.findIndex((unit) => unit.id === currentUnitId)
  return allUnits[currentIndex - 1]
}

export const hasPreviousUnit = (bookStructure, currentUnitId) => {
  const previousUnit = getPreviousUnit(bookStructure, currentUnitId)
  return !!previousUnit
}

export const getNextUnit = (bookStructure, currentUnitId) => {
  if (!bookStructure?.topics) return null
  const allUnits = getAllVisibleUnits(bookStructure.topics)
  const currentIndex = allUnits.findIndex((unit) => unit.id === currentUnitId)
  return allUnits[currentIndex + 1]
}

export const hasNextUnit = (bookStructure, currentUnitId) => {
  const nextUnit = getNextUnit(bookStructure, currentUnitId)
  return !!nextUnit
}
// END

export const isFirstPage = (sections, currentSectionId, hasCover) => {
  if (!currentSectionId) return true
  if (hasCover) return false
  return isFirstSection(sections, currentSectionId)
}

export const isLastPage = (sections, currentSectionId) => {
  return currentSectionId && isLastSection(sections, currentSectionId)
}

export const shouldApplyContentRestriction = (
  bookStructure,
  currentUnit,
  isSampleUserBookAccessType
) => {
  if (!bookStructure || !currentUnit) return undefined
  if (!isSampleUserBookAccessType) return false

  const allVisibleUnits = getAllVisibleUnits(bookStructure?.topics)
  return allVisibleUnits.length === 1
}
